// React.
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Helpers.
import { updateExpiration } from './helpers/utils';
import ConditionalRender from "./helpers/ConditionalRender";

// Types.
import InstanceTarget from './types/instance/InstanceTarget';

// Constants.
import {
	DATA_LOADED,
	DATA_LOADING, REDIRECT_PAGE,
} from './component/Constants';

// Views.
import Login from './views/login';
import Content from "./Content";
import ErrorPage from "./views/ErrorPage";

// Styles.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'highlight.js/styles/vs.css';
import 'html-query-plan/css/qp.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './css/App.css';
import './css/html-query-plan-overrides.css';
import './css/primereact-overrides.css';
import './css/primereact-execution-plans.css';
import './css/tooltip.css';
import './fonts/mfizz/font-mfizz.css';
import './fonts/fontawesome/css/all.min.css';
import './fonts/fontawesome/css/custom-icons.min.css';
import 'highlight.js/styles/vs.css'
import api from "./api/Base";

// Constants
import { TOKEN_KEY, EXPIRATION_KEY } from './component/Constants';

function App() {
    const [loading, setLoading] = useState<number>(DATA_LOADING);

    const [isLogged, setIsLogged] = useState(false);
    const [mustLogIn, setMustLogIn] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [generalError, setGeneralError] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

	useEffect(() => {
		const isLoginPage = window.location.pathname.startsWith('/login');
		if (!isLoginPage) {
			window.localStorage.setItem(REDIRECT_PAGE, window.location.href);
		}
	}, [location.pathname]);

    useEffect(() => {
		async function authenticate (token: string | null)
		{
			try
			{
				const url = process.env.REACT_APP_ARCHIVER + '/auth.jsp';
				await api<InstanceTarget[]> ({ url, baseURL:'' });
				setIsLogged (true);
				setMustLogIn (!!token);
			}
			catch (error: any)
			{
				if (error.response && error.response.status === 401)
				{
					setMustLogIn (true);
					setLoginError ('invalid');
                    navigate('/login');
				}
				else
				{
					console.error ('error', error);
					setGeneralError (error.message);
                    navigate('/error');
				}
			}
		}

		const token = window.localStorage.getItem (TOKEN_KEY);
		const expiration = window.localStorage.getItem (EXPIRATION_KEY);

		if (!token || !expiration)
		{
			authenticate (token);
		}
		else if (new Date () > new Date (expiration))
		{
			setMustLogIn (true);
			setLoginError ('expired');
			navigate ('/login?error=expired');
		}
		else
		{
			updateExpiration ();
			authenticate (token);
		}

		setLoading (DATA_LOADED);
    }, [location.pathname]);

    return (
        <>
            <ConditionalRender if={generalError && loading === DATA_LOADED}>
				<ErrorPage message={generalError}/>
            </ConditionalRender>
            <ConditionalRender if={!generalError && mustLogIn && !isLogged && loading === DATA_LOADED}>
                <Login loginError={loginError}/>
            </ConditionalRender>
            <ConditionalRender if={!generalError && isLogged && loading === DATA_LOADED}>
                <Content loginRequired={mustLogIn}/>
            </ConditionalRender>
        </>
    );
}

export default App;
